import { Dayjs } from "dayjs";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { inject, injectable } from "tsyringe";

import { autoBind } from "src/shared/decorators/autobind";
import { PgaPolicy } from "src/shared/models/pga-policy.model";
import { IncomeReceiptPdfDetail } from "src/containers/rental/models/income-receipt";
import { RentalRepository } from "src/containers/rental/repositories/rental/rental-repository";

@injectable()
class RentalService {
    constructor(
        @inject("RentalRepository") private repository: RentalRepository
    ) {}

    @autoBind
    downloadBallotMobile(
        userIdentity: string,
        policy: PgaPolicy,
        date: Dayjs
    ): void {
        this.repository.downloadBallotMobile(userIdentity, policy, date);
    }

    @autoBind
    downloadBallotDesktop(
        userIdentity: string,
        policy: PgaPolicy,
        date: Dayjs
    ): Observable<IncomeReceiptPdfDetail> {
        return this.repository
            .downloadBallotDesktop(userIdentity, policy, date)
            .pipe(
                map((data) =>
                    IncomeReceiptPdfDetail.fromJson<IncomeReceiptPdfDetail>(
                        data
                    )
                )
            );
    }
}

export { RentalService };
